
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-8995ff40!sass-loader?sourceMap!../../../vue-loader/lib/selector?type=styles&index=0!./SweetModal.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./SweetModal.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-8995ff40!../../../vue-loader/lib/selector?type=template&index=0!./SweetModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/sweet-modal-vue/src/components/SweetModal.vue
// module id = 697
// module chunks = 1